import { render, staticRenderFns } from "./ServicosV2VisaoDetalhadaValores.vue?vue&type=template&id=196fd0a3&"
import script from "./ServicosV2VisaoDetalhadaValores.vue?vue&type=script&lang=js&"
export * from "./ServicosV2VisaoDetalhadaValores.vue?vue&type=script&lang=js&"
import style0 from "./ServicosV2VisaoDetalhadaValores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDataTable,VRow,VTooltip})
